import {generateEventTimingStatus} from '#core/application/modules/tiles/event-timing-status/index.js';
import {generatePriceBoostBanner} from '#core/application/modules/tiles/price-boost-banner/index.js';
import {generateOddsButton} from '#core/application/modules/tiles/odds-button/index.js';

export function selectionCardsFactory(PALETTE) {
    const CARD_TIMING_STATUS = generateEventTimingStatus(PALETTE.CARD_TIMING_STATUS);

    return {
        SelectionCard: {
            showBackgroundSportImage: !PALETTE.PARENT.CARD_WATERMARK_ICON_HIDDEN,
            sportIcon: {
                icon: {
                    style: {
                        fill: PALETTE.CARD_SPORT_ICON_COLOR,
                        minWidth: 12,
                    },
                },
            },
            countryIcon: {
                icon: {
                    style: {
                        fill: PALETTE.CARD_SPORT_ICON_COLOR,
                        minWidth: 12,
                    },
                },
            },
            genericEventCard: {
                container: {
                    createStackingContext: true,
                },
                title: {
                    truncate: true,
                    ellipsisOnLineNumber: 1,
                    style: PALETTE.CARD_EVENT_NAME_TEXT,
                },
            },
            boostedEventCard: {
                container: {
                    createStackingContext: true,
                },
                title: {
                    truncate: true,
                    ellipsisOnLineNumber: 1,
                    style: PALETTE.CARD_EVENT_NAME_TEXT,
                },
                clickableArea: {
                    style: {
                        base: {
                            padding: '0 0 8px',
                        },
                    },
                },
            },
            headerTime: CARD_TIMING_STATUS,
            headerLiveLabel: CARD_TIMING_STATUS.liveText,
            selectionName: {
                default: {
                    style: {
                        lineHeight: '1.3', // better to set it here and store it as a string, cool Moj decision (selection-card.jsx:24)
                        ...PALETTE.CARD_SELECTION_NAME_TEXT,
                    },
                },
                withPromotionText: {
                    style: {
                        lineHeight: 1.3,
                        ...PALETTE.CARD_SELECTION_PROMOTION_TEXT,
                    },
                },
            },
            marketName: {
                default: {
                    style: {
                        ...PALETTE.CARD_SELECTION_MARKET_TEXT,
                    },
                },
                withPromotionText: {
                    style: {
                        lineHeight: 1.3,
                        ...PALETTE.CARD_SELECTION_MARKET_TEXT,
                    },
                },
            },
            promotionText: {
                style: {
                    lineHeight: 1.3,
                    ...PALETTE.CARD_SELECTION_NAME_TEXT,
                },
            },
            selectionButton: generateOddsButton(PALETTE.EVENT_CARDS_ODDS_BUTTON),
            priceBoostBanner: generatePriceBoostBanner(PALETTE.CARD_SELECTION_PRICE_BOOST_BANNER),
            separatorLabel: {
                style: PALETTE.CARD_EVENT_NAME_TEXT,
            },
            threeParticipantText: {
                style: PALETTE.CARD_EVENT_NAME_TEXT,
            },
            participantItem: {
                participantWrapper: {
                    style: {
                        flexGrow: 0,
                    },
                },
                text: {
                    style: PALETTE.CARD_EVENT_NAME_TEXT,
                },
            },
            competitorIconOptions: {
                icons: {
                    default: 'generic/team-kit-default.svg',
                },
            },
        },
    };
}
